import React from 'react'

const Footer = () => {
    return (
        <div>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <p className="text-center">
                        © Kenneth Sørensen 2022
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
